import axios from 'axios';

export const selectCurrentLoanApplication = async (id: string) => {
  await axios.post<null>('/api/v1/current-loan-application/select', {
    loan_application_id: id,
  });
};
